export const EditListingTourConfigSteps = {
  SET_BOOKING_METHOD: 'setBookingMethod',
  SET_TIME_ZONE: 'setTimeZone',
  SET_AVAILABILITY: 'setAvailability',
  EDIT_BOOKING_METHOD: 'editBookingMethod',
  EDIT_AVAILABILITY: 'editAvailability',
} as const;

export type EditListingTourConfigSteps = (typeof EditListingTourConfigSteps)[keyof typeof EditListingTourConfigSteps];
